// NGRX
import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
// Models
import {LocationDescription} from '../_models/location-description.model';

export enum LocationDescriptionActionTypes {

    AllLocationDescriptionsRequested = '[LocationDescriptions Home Page] All LocationDescriptions Requested',
    AllLocationDescriptionsLoaded = '[LocationDescriptions API] All LocationDescriptions Loaded',

    LocationDescriptionOnServerCreated = '[Edit LocationDescription Dialog] LocationDescription On Server Created',
    LocationDescriptionCreated = '[Edit LocationDescriptions Dialog] LocationDescriptions Created',
    LocationDescriptionUpdated = '[Edit LocationDescription Dialog] LocationDescription Updated',
    LocationDescriptionDeleted = '[LocationDescriptions List Page] LocationDescription Deleted',

    LocationDescriptionsPageRequested = '[LocationDescriptions List Page] LocationDescriptions Page Requested',
    LocationDescriptionsPageLoaded = '[LocationDescriptions API] LocationDescriptions Page Loaded',
    LocationDescriptionsPageCancelled = '[LocationDescriptions API] LocationDescriptions Page Cancelled',

    LocationDescriptionsPageToggleLoading = '[LocationDescriptions page] LocationDescriptions Page Toggle Loading',
    LocationDescriptionsActionToggleLoading = '[LocationDescriptions] LocationDescriptions Action Toggle Loading',

    // trash system

    LocationDescriptionOnServerRestored = '[LocationDescription Trash] LocationDescription On Server Restored',
    LocationDescriptionRestored = '[LocationDescription Trash] LocationDescription Restored',

    LocationDescriptionOnServerAdminRestored = '[LocationDescription Admin Trash] LocationDescription On Server Restored',
    LocationDescriptionAdminRestored = '[LocationDescription Admin Trash] LocationDescription Restored',

    LocationDescriptionDeletedFromTrash = '[LocationDescription Trash] LocationDescription deleted',
    LocationDescriptionDeletedFromAdminTrash = '[LocationDescription Admin Trash] LocationDescription deleted',

    LocationDescriptionTrash = 'LocationDescription Trashed',
    LocationDescriptionTrashFlushed = 'LocationDescription Trash Flushed',
}

export class LocationDescriptionOnServerCreated implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionOnServerCreated;

    constructor(public payload: { locationDescription: LocationDescription}) {
    }
}

export class LocationDescriptionCreated implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionCreated;

    constructor(public payload: { locationDescription: LocationDescription }) {
    }
}

export class LocationDescriptionUpdated implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionUpdated;

    constructor(public payload: {
        partialLocationDescription: Update<LocationDescription>,
        locationDescription: LocationDescription
    }) {
    }
}

export class LocationDescriptionDeleted implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionDeleted;

    constructor(public payload: { id: number }) {
    }
}

export class LocationDescriptionsPageRequested implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionsPageRequested;

    constructor(public payload: { page: QueryParamsModel }) {
    }
}

export class LocationDescriptionsPageLoaded implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionsPageLoaded;

    constructor(public payload: { locationDescriptions: LocationDescription[], totalCount: number, totalTrashed: number, totalAdminTrashed: number, page: QueryParamsModel }) {
    }
}

export class LocationDescriptionsPageCancelled implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionsPageCancelled;
}

export class AllLocationDescriptionsRequested implements Action {
    readonly type = LocationDescriptionActionTypes.AllLocationDescriptionsRequested;
}

export class AllLocationDescriptionsLoaded implements Action {
    readonly type = LocationDescriptionActionTypes.AllLocationDescriptionsLoaded;

    constructor(public payload: { locationDescriptions: LocationDescription[] }) {
    }
}

export class LocationDescriptionsPageToggleLoading implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionsPageToggleLoading;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class LocationDescriptionsActionToggleLoading implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionsActionToggleLoading;

    constructor(public payload: { isLoading: boolean }) {
    }
}

// Trash

export class LocationDescriptionDeletedFromAdminTrash implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionDeletedFromAdminTrash;

    constructor(public payload: { id: number }) {
    }
}


export class LocationDescriptionDeletedFromTrash implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionDeletedFromTrash;

    constructor(public payload: { id: number }) {
    }
}

export class LocationDescriptionOnServerRestored implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionOnServerRestored;

    constructor(public payload: { id: number }) {
    }
}

export class LocationDescriptionRestored implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionRestored;

    constructor(public payload: { item: LocationDescription }) {
    }
}

export class LocationDescriptionOnServerAdminRestored implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionOnServerAdminRestored;

    constructor(public payload: { id: number }) {
    }
}

export class LocationDescriptionAdminRestored implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionAdminRestored;

    constructor(public payload: { item: LocationDescription }) {
    }
}

export class LocationDescriptionTrashFlushed implements Action {
    readonly type = LocationDescriptionActionTypes.LocationDescriptionTrashFlushed;

    constructor() {
    }
}

export type LocationDescriptionActions = LocationDescriptionCreated
    | LocationDescriptionUpdated
    | LocationDescriptionDeleted
    | LocationDescriptionsPageRequested
    | LocationDescriptionsPageLoaded
    | LocationDescriptionsPageCancelled
    | AllLocationDescriptionsLoaded
    | AllLocationDescriptionsRequested
    | LocationDescriptionOnServerCreated
    | LocationDescriptionsPageToggleLoading
    | LocationDescriptionsActionToggleLoading
    | LocationDescriptionDeletedFromAdminTrash
    | LocationDescriptionDeletedFromTrash
    | LocationDescriptionOnServerRestored
    | LocationDescriptionRestored
    | LocationDescriptionOnServerAdminRestored
    | LocationDescriptionAdminRestored
    | LocationDescriptionTrashFlushed;
